import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { useKindeAuth } from '@kinde-oss/kinde-auth-react';
import { ProgressProvider } from './contexts/ProgressContext';
import Dashboard from './pages/Dashboard';
import ChapterView from './pages/ChapterView';
import QuizView from './pages/QuizView';
import Certificate from './pages/Certificate';
import LoginView from './components/LoginView';

function AppContent() {
  // Always call hooks unconditionally (React rules of hooks)
  const kindeAuth = useKindeAuth();
  const isKindeConfigured = Boolean(import.meta.env.VITE_KINDE_DOMAIN && import.meta.env.VITE_KINDE_CLIENT_ID);

  if (isKindeConfigured && kindeAuth) {
    if (kindeAuth.isLoading) {
      return (
        <div className="min-h-screen bg-slate-900 text-white flex items-center justify-center">
          <div className="flex flex-col items-center gap-3">
            <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
            <p className="text-slate-400 text-sm">Verifying authentication...</p>
          </div>
        </div>
      );
    }

    if (!kindeAuth.isAuthenticated) {
      return <LoginView />;
    }
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/chapter/:day" element={<ChapterView />} />
        <Route path="/quiz/:day" element={<QuizView />} />
        <Route path="/certificate" element={<Certificate />} />
      </Routes>
    </Router>
  );
}

function App() {
  return (
    <ProgressProvider>
      <AppContent />
    </ProgressProvider>
  );
}

export default App;
